import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import Image from '../../image'
import Typography from '../../typography'
import { useBreakpoint } from '../../../../hooks/breakpoint'

const ExtraDetails = ({ course, ...attrs }) => {
  const breakpoint = useBreakpoint()

  const hasExtraDetails = get(course, 'extraDetails.length', 0) > 0

  attrs.className = classNames(
    attrs.className,
    [
      breakpoint.mdAndUp ? 'border' : '',
      breakpoint.mdAndUp ? 'border-gray-300' : '',
      breakpoint.mdAndUp ? 'p-6' : ''
    ]
  )
  return hasExtraDetails
    ? <div
      {...attrs}>
      {
        course.extraDetails.map(
          (item, index) => {
            const { icon, title, text } = item.value
            const lastItem = (index === course.extraDetails.length - 1)
            return <div
              key={item.id}
              className={
                !lastItem ? 'mb-6' : ''
              }>
              <div
                className={
                  classNames([
                    'flex',
                    'flex-row',
                    'items-center',
                    'mb-2'
                  ])
                }>
                <Image
                  src={icon.meta.downloadUrl}
                  className={'mr-3'}
                  style={{
                    width: '1.75rem',
                    height: '1.75rem'
                  }} />
                <Typography
                  size={'three'}
                  weight={'bold'}
                  className={'text-green-600'}>
                  {title}
                </Typography>
              </div>
              <Typography
                tag={'div'}
                size={'two'}
                weight={'regular'}>
                {text}
              </Typography>
            </div>
          }
        )
      }
    </div>
    : null
}

ExtraDetails.propTypes = {
  course: PropTypes.object
}

export default ExtraDetails
